import {
  getPregnancyPrimaryCoverageField,
  getPregnancySecondaryCoverageField,
  InsuranceInfo,
  insuranceInfoStage,
} from '@hb/shared'

export const getInsuranceInfoValidationField = (
  insuranceInfo: Partial<InsuranceInfo> | undefined,
  admin: boolean,
) => {
  const children = {
    ...insuranceInfoStage.children,
  }

  const primaryCoverageField = getPregnancyPrimaryCoverageField(insuranceInfo, admin)
  if (primaryCoverageField) {
    children.primaryCoverage = primaryCoverageField
  }

  const secondaryCoverageField = getPregnancySecondaryCoverageField(insuranceInfo, admin)
  if (secondaryCoverageField) {
    children.secondaryCoverage = secondaryCoverageField
  }
  return {
    ...insuranceInfoStage,
    children,
  }
}
